<template>
  <v-card color="blue-grey lighten-5" flat rounded="lg" class="pa-3">
    <div
      class="d-flex align-center justify-space-between flex-wrap"
      style="gap: 12px"
    >
      <div v-if="error" class="d-flex align-center" style="gap: 8px">
        <v-icon color="error">mdi-alert-circle</v-icon>
        <span class="text-error">{{ error }}</span>
      </div>
      <div v-else class="d-flex align-center" style="gap: 8px">
        <v-icon>mdi-account-multiple</v-icon>
        <span class="font-weight-bold">
          {{ isLoading ? 'ー/ー' : `${usedCount}/${totalCount}` }}
        </span>
        <span>ー</span>
        <span>
          {{
            isLoading
              ? 'ー'
              : $t('distribution.ticketsOverview.seatsAvailable', {
                  count: unusedCount,
                })
          }}
        </span>
      </div>
      <v-btn
        small
        outlined
        depressed
        color="blue-grey darken-5"
        class="white"
        :disabled="isLoading"
        @click="$emit('see-tickets')"
      >
        <v-icon class="mr-2" size="small">
          mdi-ticket-confirmation-outline
        </v-icon>
        {{ $t('distribution.ticketsOverview.buttonText') }}
      </v-btn>
    </div>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "TicketsOverview",
  props: {
    usedCount: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    unusedCount: {
      type: Number,
      default: 0,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: undefined,
    },
  },
});
</script>
